import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { SmallFlatButton, SmallRaisedButton } from '../../../../tc-ui/small-buttons';

const SingleTemplate = ({
  template: t,
  selected,
  onSelect,
  onUnselect,
  openRateDocIframe,
  forCCImport,
}) => {
  const previewCCRateDoc = () => {
    return openRateDocIframe({
      url: `${t.magicLink}&jumpBackTo=${window.location.href}`,
      collection: t.originalContractId ? 'draft' : 'template',
      rateDocId: t.originalContractId || t._id,
      forCCImport,
      forImport: true,
    });
  };
  return (
    <div className="flex-tc-sb" style={{ marginTop: '8px' }}>
      <small style={{ width: t.completionPercent === 100 ? '430px' : '350px', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {
          (() => {
            if (!forCCImport && t.templateName) {
              return t.templateName;
            }
            if (t.locationName === t.supplierCompanyName || t.supplierCompanyName.indexOf('(RC)') > -1) {
              return t.locationName;
            }
            return `${t.supplierCompanyName} - ${t.locationName}`;
          })()
        }
        {Boolean(t.supplierInfo && t.supplierInfo.marketInfo) && (
          <small>&nbsp;&nbsp;({t.supplierInfo.marketInfo})</small>
        )}
      </small>
      <small style={{ width: '80px', fontSize: '10px', textAlign: 'right', display: t.completionPercent === 100 ? 'none' : 'block' }}>
        {`${t.completionPercent || 80}% complete`}
      </small>
      <small>
      {moment.utc(t.startDate).format('l')} - {moment.utc(t.endDate).format('l')}
      </small>
      <div className="flex-center">
        {
          selected
          ? (
            <SmallRaisedButton
              label="Unselect"
              primary
              onClick={onUnselect}
            />
          )
          : (
            <SmallRaisedButton
              label="Select"
              secondary
              onClick={onSelect}
            />
          )
        }&nbsp;&nbsp;
        <SmallFlatButton
          label="Preview"
          secondary
          style={{ border: '1px solid #00bcd4' }}
          labelStyle={{ bottom: '2px' }}
          onClick={previewCCRateDoc}
        />
        {/* &nbsp;&nbsp;
        <span className="hint--top" aria-label="Open in a new tab">
          <LaunchIcon style={{ color: 'rgba(0, 0, 0, 0.54)', cursor: 'pointer' }} onClick={openInNewWindow(t)}/>
        </span> */}
      </div>
    </div>
  );
};

export default connect(null, {
  openRateDocIframe: payload => ({
    type: '{dummy-account} RateDocIframe_open',
    payload,
  }),
})(SingleTemplate);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/import-template/single-template.jsx